export const OPEN_MODAL = "OPEN_MODAL"
export const OPEN_RC = "OPEN_RC"
export const OPEN_MS = "OPEN_MS"
export const OPEN_TOUR = "OPEN_TOUR"
export const OPEN_WELCOME = "OPEN_WELCOME"
export const OPEN_ANN = "OPEN_ANN"
export const NOTIFY = "NOTIFY"
export const OPEN_MODAL_CENTER = 'OPEN_MODAL_CENTER'
export const CLOSE_MODAL_CENTER = 'CLOSE_MODAL_CENTER'
export const TOGGLE_MODAL_CENTER = 'TOGGLE_MODAL_CENTER'
